import {createSelector} from 'reselect';
import {compose, pathOr, startsWith, equals} from 'ramda';

import {ApplicationStoreType} from 'reducers';

import {RouterType} from './routerType';

/**
 * Get router data
 * @param {ApplicationStoreType} store - Application store
 * @return {RouterType} Router data
 */
export const getRouter = (store: ApplicationStoreType): RouterType => store.router;

/**
 * Determines if user is on contact lenses page.
 * @type {SelectorType<boolean>}
 */
export const isContactLensesPage: (store: ApplicationStoreType) => boolean = createSelector(
    getRouter,
    compose(startsWith('/contact-lenses'), pathOr('', ['location', 'pathname'])),
);

/**
 * Determines if user is on home page.
 * @type {SelectorType<boolean>}
 */
export const isHomePage: (store: ApplicationStoreType) => boolean = createSelector(
    getRouter,
    compose(equals('/'), pathOr('', ['location', 'pathname'])),
);

/**
 * Determines if user is on search page.
 * @type {SelectorType<boolean>}
 */
export const isSearchPage: (store: ApplicationStoreType) => boolean = createSelector(
    getRouter,
    compose(startsWith('/salesperson/result'), pathOr('', ['location', 'pathname'])),
);

/**
 * Get type of the current page
 * @type {SelectorType<string>}
 */
export const getPageType: (store: ApplicationStoreType) => string = createSelector(
    getRouter,
    pathOr('', ['location', 'state', 'page']),
);

/**
 * Get type of the previous page
 * @type {SelectorType<string>}
 */
export const getPrevPageType: (store: ApplicationStoreType) => string = createSelector(
    getRouter,
    pathOr('', ['location', 'state', 'prevPage', 'type']),
);

/**
 * Get parameters from search
 * @param {ApplicationStoreType} store - Application store
 * @return {string} search data
 */
export const getSearchParams: (store: ApplicationStoreType) => string = createSelector(
    getRouter,
    pathOr('', ['location', 'search']),
);
